import { useTonConnectModal, useTonConnectUI } from '@tonconnect/ui-react';
import { useEffect, useState } from 'react';
import { useProxyLocalStorage } from '../v2/ProxyLocalStorage';
import { getTonBalance } from '../config/ton';
import { ConnectResult } from '../TomoContext';

interface Option {
  connectSuccess?: () => void;
  connectError?: () => void;
  setProviders: (providers: Record<string, any>) => void;
  // chain?: string;
  setConnectResult?: (result: ConnectResult) => void;
}

const useTonConnect = (option: Option) => {
  const { connectSuccess, connectError, setProviders, setConnectResult } =
    option || {};
  const [tonConnectUI] = useTonConnectUI();
  const { open } = useTonConnectModal();

  const storage = useProxyLocalStorage();

  const connect = async (connectParams?: { tonProof?: string }) => {
    if (connectParams?.tonProof) {
      tonConnectUI.setConnectRequestParameters({
        state: 'ready',
        value: { tonProof: connectParams.tonProof },
      });
    }
    open();
    return 'connect';
  };

  const connectType = storage.get('connect_type');

  useEffect(() => {
    if (connectType === 'TON' && !tonConnectUI.connected) {
      disconnect();
    }
  }, [tonConnectUI.connected, connectType]);

  const disconnect = async () => {
    setProviders(pre => ({ ...pre, tomo_ton: null }));
    storage.set('accounts', {
      ...(storage.get('accounts') || {}),
      ton: undefined,
    });
    window.tomo_ton = null;
    storage.set('connect_type', '');
  };

  useEffect(() => {
    if (tonConnectUI.connected && tonConnectUI.account?.address) {
      // is connected
      connectSuccess && connectSuccess();
      const account = tonConnectUI.account;
      storage.set('accounts', {
        ...(storage.get('accounts') || {}),
        ton: account,
      });
      storage.set('connect_type', 'TON');
      Object.defineProperty(tonConnectUI, 'getBalance', {
        value: async () => getTonBalance({ tonAddress: account.address }),
        writable: true,
        enumerable: true,
        configurable: false,
      });
      window.tomo_ton = tonConnectUI;
      setProviders &&
        setProviders(pre => ({
          ...(pre || {}),
          tomo_ton: tonConnectUI,
        }));
    }
  }, [tonConnectUI.connected, tonConnectUI.account?.address]);

  useEffect(() => {
    const unsub = tonConnectUI.onStatusChange((wallet) => {
      if (
        wallet?.connectItems?.tonProof &&
        "proof" in wallet.connectItems.tonProof
      ) {
        setConnectResult({
          result: { tonProof: wallet.connectItems.tonProof },
        });
      }
    });
    return () => {
      unsub()
    }
  }, [tonConnectUI]);

  return {
    connect,
    disconnect,
    connected: tonConnectUI?.connected || false,
  };
};

export default useTonConnect;
